module.exports = __webpack_public_path__ + "img/floweringshrub.1440479d.webp";